import { Component } from '@angular/core';
import { getAllJobs } from '@modules/reports/store/referral-reports.selectors';
import { Store } from '@ngrx/store';
import {
  loadAllJobsByParams,
  loadJobDepartments,
} from '@modules/reports/store/referral-reports.actions';
import { JobsPageFilterType } from '@modules/jobs-page/store/filter/filter.reducer';
import { JobStatusEnum } from '@shared/models/job-statuses';
import { Subpages } from '@modules/reports/models/subpages';
import {
  allDepartments,
  allFunctions,
} from '@modules/reports/models/all-functions-and-departments';
import {
  loadActiveJobsCount,
  loadAggregatedMatches,
  loadTotalDirectPerPhase,
} from '@collections/aggregations';

@Component({
  selector: 'mojo-pipeline-page',
  styleUrls: ['./pipeline-page.container.scss'],
  templateUrl: './pipeline-page.container.html',
})
export class PipelinePageContainerComponent {
  selectAllActiveJobs$ = this.store.select(getAllJobs);
  constructor(private store: Store<{}>) {}

  params = {
    jobAssignedTo: JobsPageFilterType.ALL,
    offset: 0,
    status: JobStatusEnum.Published,
    jobFunction: JobsPageFilterType.ALL,
    jobDepartment: JobsPageFilterType.ALL,
    searchByRecruiter: '',
  };

  loadPipelineChartData() {
    this.store.dispatch(
      loadAggregatedMatches({
        filters: {
          jobFunction: this.mapFunctionOrDepartment(false),
          jobDepartment: this.mapFunctionOrDepartment(true),
          jobStatus: this.params.status,
          searchByRecruiter: this.params.searchByRecruiter,
        },
      }),
    );
    this.store.dispatch(
      loadTotalDirectPerPhase({
        filters: {
          jobFunction: this.mapFunctionOrDepartment(false),
          jobDepartment: this.mapFunctionOrDepartment(true),
          jobStatus: this.params.status,
          searchByRecruiter: this.params.searchByRecruiter,
        },
      }),
    );
    this.store.dispatch(
      loadActiveJobsCount({
        filters: {
          jobFunction: this.mapFunctionOrDepartment(false),
          jobDepartment: this.mapFunctionOrDepartment(true),
          jobStatus: this.params.status,
          searchByRecruiter: this.params.searchByRecruiter,
        },
      }),
    );
  }

  applyFilters(obj) {
    this.params = {
      ...this.params,
      jobFunction:
        obj.selectedFunction === allFunctions ? JobsPageFilterType.ALL : obj.selectedFunction,
      jobDepartment:
        obj.selectedDepartment === allDepartments ? JobsPageFilterType.ALL : obj.selectedDepartment,
    };
    this.changePage(0);
    this.store.dispatch(
      loadJobDepartments({
        filters: {
          jobFunction: obj.selectedFunction,
          jobStatus: this.params.status,
        },
        departmentsPage: Subpages.PIPELINE,
      }),
    );
    this.loadPipelineChartData();
  }

  changeJobStatus(obj) {
    this.params = {
      ...this.params,
      status: obj.selectedJobStatus,
    };
    this.changePage(0);
    this.store.dispatch(
      loadJobDepartments({
        filters: {
          jobFunction: this.mapFunctionOrDepartment(false),
          jobStatus: obj.selectedJobStatus,
        },
        departmentsPage: Subpages.PIPELINE,
      }),
    );
    this.loadPipelineChartData();
  }

  changeCandidateOrHiringManager(selectedCandidateOrHiringManager) {
    this.params = {
      ...this.params,
      searchByRecruiter: selectedCandidateOrHiringManager,
    };
    this.changePage(0);
    this.loadPipelineChartData();
  }
  changePage(offset) {
    this.store.dispatch(
      loadAllJobsByParams({
        params: { ...this.params, offset },
      }),
    );
  }

  mapFunctionOrDepartment(isDepartmentMapping) {
    const allValue = isDepartmentMapping ? allDepartments : allFunctions;
    const currentValue = isDepartmentMapping ? this.params.jobDepartment : this.params.jobFunction;
    return currentValue === JobsPageFilterType.ALL ? allValue : currentValue;
  }
}
